// extracted by mini-css-extract-plugin
export var aboveInput = "_na-0";
export var actionButton = "_na-5";
export var actionButtonContainer = "_na-1";
export var actionIcon = "_na-6";
export var aiInfoContainer = "_na-2";
export var attachmentWrapper = "_na-7";
export var bold = "_na-3";
export var checkIcon = "_na-8";
export var clickingRecipientBar = "_na-11";
export var commentThreadSwitch = "_na-a";
export var draftImage = "_na-b";
export var draftImageContainer = "_na-c";
export var draftImages = "_na-e";
export var editButton = "_na-g";
export var editor = "_na-f";
export var editorContainer = "_na-y";
export var editorErrorTooltipWrapper = "_na-9";
export var headerDivider = "_na-h";
export var icon = "_na-i";
export var info = "_na-j";
export var internal = "_na-n";
export var internalDivider = "_na-k";
export var internalMessage = "_na-l";
export var messageInputCard = "_na-m";
export var messageInputForm = "_na-o";
export var messageInputFormInternal = "_na-p";
export var options = "_na-q";
export var publicMessageCustomer = "_na-s";
export var publicMessageMerchant = "_na-r";
export var removeImageButton = "_na-d";
export var replyButtons = "_na-t";
export var showSignatureButton = "_na-u";
export var spinner = "_na-v";
export var verticalButtonDivider = "_na-4";
export var visibilitySelector = "_na-w";
export var warning = "_na-x";
export var wrappingText = "_na-z";
export var writingInternalNoteTopBorder = "_na-10";